export abstract class ErrorUtils {
    static stacktraceToStringList(err: Error): any {
      return err.stack?.split('\n').map(line => { return line.trim(); }) ?? [];
    }
}
